import "core-js/modules/es6.function.name";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    ref: "modal",
    attrs: {
      "width": 640,
      "title": _vm.title
    },
    model: {
      value: _vm.modalVisible,
      callback: function callback($$v) {
        _vm.modalVisible = $$v;
      },
      expression: "modalVisible"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "myform",
    attrs: {
      "model": _vm.data,
      "rules": _vm.rules,
      "label-width": 100,
      "showMessage": false,
      "autocomplete": "off",
      "novalidate": ""
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "group",
      "label": "角色"
    }
  }, [_c('Select', {
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('group');
      }
    },
    model: {
      value: _vm.data.group,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "group", $$v);
      },
      expression: "data.group"
    }
  }, _vm._l(_vm.groups, function (c) {
    return _c('Option', {
      key: c.id,
      attrs: {
        "value": c.id
      }
    }, [_vm._v(_vm._s(c.name))]);
  }), 1)], 1)], 1), _c('template', {
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "loading": _vm.loading,
      "disabled": !_vm.isFormValid
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("确定")]), _c('Button', {
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };